import React from "react";
import { Button } from "antd";

// Components
import DeliveryProfile from "./components/DeliveryProfile";
import DeliveryLayout from "./DeliveryLayout";

// Custom hook
import useDeliveryData from "./hooks/useDeliveryData";

const DeliveryProfilePage = () => {
  const { bikerProfile, loading, updateBikerProfile } = useDeliveryData();

  return (
    <DeliveryLayout>
      <div className="pb-40">
        <div className="main_container_title_div mb-5 mt-10 flex items-center justify-between">
          <h5 className="!mt-0">My Delivery Profile</h5>
          <Button
            type="primary"
            onClick={() => console.log("Edit profile")}
            className="bg-black hover:bg-gray-800"
            style={{ backgroundColor: "#000000", borderColor: "#000000" }}
          >
            Edit My Profile
          </Button>
        </div>
        <DeliveryProfile
          bikerProfile={bikerProfile}
          onUpdateProfile={updateBikerProfile}
          loading={loading}
        />
      </div>
    </DeliveryLayout>
  );
};

export default DeliveryProfilePage;
